import { defineComponent as _defineComponent } from 'vue'
import Se2aDataList from "@/components/se2a-data-list.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const headers = [
  {text: "Type", value: "type.name"},
  {text: 'Workline', value: 'workline'},
  {text: 'Status', value: 'metadata.status'},
  {text: 'Title', value: 'title'},
  {text: 'Authors', value: 'fields.author'},
  {text: '', sortable: false, align: 'right', value: 'action'}
];

const filters = [
  {name: 'Type', on: 'type.name'},
  {name: 'Workline', on: 'workline'},
  {name: 'Title', on: 'title'}
]


return { __sfc: true,headers, filters, Se2aDataList }
}

})